<template>
  <div>
    <el-dialog class="book_dialog" title="顾客列表" :visible.sync="visible" :show="show" :close-on-click-modal="false" :append-to-body="true" width="800px" @close="$emit('update:show', false)">
      <el-input v-model="phone" class="width_242" placeholder="请输入手机尾号/顾客姓名" :maxlength="11" @keyup.enter.native="getCustomerList('blur')" @blur="getCustomerList('blur')">
        <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="getCustomerList()"></i>
      </el-input>
      <br />
      <br />
      <el-table ref="multipleTable" tooltip-effect="light" :data="tableData" :row-style="{height:'30px'}" class="multipleTable" header-cell-class-name="book_sel" @sort-change="onSortChange" @row-click="onRowClick">
        <el-table-column type="selection" width="35">
          <template slot-scope="scope">
            <el-radio v-model="choosePackageRadio" :label="scope.row.id"> </el-radio>
          </template>
        </el-table-column>
        <el-table-column property="customerName" label="顾客姓名" show-overflow-tooltip></el-table-column>
        <el-table-column :sortable="'custom'" property="memberType" label="顾客身份">
          <template slot-scope="scope">
            <div v-if="scope.row.memberType == 0" class="not_member_css">非会员</div>
            <div v-else class="member_css">{{ scope.row.grade }}</div>
          </template>
        </el-table-column>
        <el-table-column property="phone" label="手机号码">
          <template slot-scope="scope">
            {{ Lib.starPhone(scope.row.phone) }}
          </template>
        </el-table-column>
        <el-table-column :sortable="'custom'" property="expenseTime" label="最近消费日期">
          <template slot-scope="scope">
            {{ scope.row.expenseTime || '--' }}
          </template>
        </el-table-column>
      </el-table>
      <p slot="footer" class="dialog-footer">
        <el-pagination :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="total" background @current-change="getCustomerList"></el-pagination>
        <span>
          <el-button @click="visible = false">取 消</el-button>
          <el-button type="primary" @click="confirmContactMember">确 定</el-button>
        </span>
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { getSimpleCustomerMsgListPage } from '../api';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.show,
      tableData: [],
      pageNum: 1,
      total: 0,
      phone: '',
      isAsc: 0,
      select_row: {}, // 选择行
      choosePackageRadio: 0,
      confirmMember: 0,
      sortType: 0
    };
  },
  watch: {
    show() {
      this.visible = this.show;
      this.pageNum = 1;
      if (this.show) {
        this.phone = '';
        this.confirmMember = 0;
        this.choosePackageRadio = null;
        this.select_row = {};
        setTimeout(() => {
          this.$refs.multipleTable.clearSort();
        }, 100);
        this.getCustomerList();
      } else if (this.confirmMember === 1) {
        this.$parent.checkMember(this.select_row.phone, this.select_row.customerName, this.select_row.memberType);
      }
    }
  },
  activated() { },
  methods: {
    getCustomerList(val) {
      if (val === 'blur') {
        this.pageNum = 1;
      }
      const data = {
        mainId: window.sessionStorage.mainId,
        busId: sessionStorage.getItem('busId'),
        sortType: this.sortType,
        pageNum: this.pageNum,
        pageSize: 10,
        phone: this.phone,
        isAsc: this.isAsc,
      };
      getSimpleCustomerMsgListPage(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 当排序条件发生变化时
    onSortChange({ column, prop, order }) {
      // descending 是顺序 ascending是逆序
      if (!column && !prop && !order) {
        this.isAsc = 1;
      }
      if (prop === 'expenseTime' && order === 'descending') {
        this.sortType = 0;
        this.isAsc = 1;
      }
      if (prop === 'expenseTime' && order === 'ascending') {
        this.sortType = 0;
        this.isAsc = 0;
      }
      if (prop === 'expenseTime' && order === null) {
        this.sortType = 0;
        this.isAsc = 0;
      }
      if (prop === 'memberType' && order === 'ascending') {
        this.sortType = 1;
        this.isAsc = 1;
      }
      if (prop === 'memberType' && order === 'descending') {
        this.sortType = 1;
        this.isAsc = 0;
      }
      if (prop === 'memberType' && order === null) {
        this.sortType = 0;
        this.isAsc = 0;
      }
      this.pageNum = 1;
      this.phone = '';
      this.getCustomerList();
    },
    // 点击行
    onRowClick(row) {
      this.choosePackageRadio = row.id;
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
      this.select_row = row;
    },
    onDbRowClick(row, column, event) {
      this.onRowClick(row, column, event);
      this.visible = false;
    },
    confirmContactMember() {
      this.visible = false;
      this.confirmMember = 1;
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-dialog__footer {
  padding-top: 0px;
}
.member_css {
  height: 28px;
  margin: 1px 0;
  background: rgba(255, 237, 241, 1);
  box-shadow: 0 0 0 1px rgba(255, 204, 219, 1);
  border-radius: 4px;
  font-size: 15px;
  color: rgba(253, 92, 140, 1);
  text-align: center;
  line-height: 28px;
  font-size: 12px;
  max-width: 100px;
}
.not_member_css {
  height: 28px;
  margin: 1px 0;
  background: rgba(244, 244, 245, 1);
  box-shadow: 0 0 0 1px rgba(229, 229, 232, 1);
  border-radius: 4px;
  font-size: 15px;
  color: rgba(144, 147, 153, 1);
  text-align: center;
  line-height: 28px;
  font-size: 12px;
  max-width: 100px;
}
</style>
<style >
.book_sel > .cell > .el-checkbox > .el-checkbox__input {
  display: none !important;
}
</style>
